import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconInternet = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 23.94'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,23.932 C5.383,23.932 -0.000,18.561 -0.000,11.959 C-0.000,5.357 5.383,-0.014 12.000,-0.014 C18.617,-0.014 24.000,5.357 24.000,11.959 C24.000,18.561 18.617,23.932 12.000,23.932 ZM20.627,16.948 L18.156,16.948 C17.645,18.432 16.913,19.837 15.974,21.110 C17.939,20.257 19.556,18.781 20.627,16.948 ZM16.009,16.948 L13.000,16.948 L13.000,21.471 C14.310,20.164 15.326,18.623 16.009,16.948 ZM17.000,11.959 C17.000,10.941 16.869,9.940 16.641,8.966 L13.000,8.966 L13.000,14.952 L16.640,14.952 C16.869,13.978 17.000,12.977 17.000,11.959 ZM11.000,16.948 L7.989,16.948 C8.673,18.625 9.689,20.168 11.000,21.475 L11.000,16.948 ZM8.021,21.108 C7.083,19.835 6.353,18.431 5.842,16.948 L3.373,16.948 C4.443,18.779 6.059,20.255 8.021,21.108 ZM2.000,11.959 C2.000,13.002 2.165,14.007 2.464,14.952 L5.308,14.952 C5.113,13.974 5.000,12.974 5.000,11.961 C5.000,10.947 5.113,9.946 5.309,8.966 L2.464,8.966 C2.165,9.912 2.000,10.916 2.000,11.959 ZM3.373,6.970 L5.844,6.970 C6.355,5.486 7.087,4.081 8.026,2.808 C6.061,3.661 4.444,5.138 3.373,6.970 ZM11.000,2.450 C9.691,3.755 8.674,5.296 7.991,6.970 L11.000,6.970 L11.000,2.450 ZM7.360,8.966 C7.131,9.941 7.000,10.942 7.000,11.961 C7.000,12.978 7.131,13.979 7.359,14.952 L11.000,14.952 L11.000,8.966 L7.360,8.966 ZM13.000,6.970 L16.010,6.970 C15.326,5.295 14.310,3.753 13.000,2.446 L13.000,6.970 ZM15.977,2.809 C16.915,4.082 17.646,5.487 18.157,6.970 L20.627,6.970 C19.557,5.139 17.940,3.662 15.977,2.809 ZM21.536,8.966 L18.691,8.966 C18.887,9.945 19.000,10.945 19.000,11.959 C19.000,12.973 18.887,13.973 18.691,14.952 L21.536,14.952 C21.835,14.007 22.000,13.002 22.000,11.959 C22.000,10.916 21.835,9.912 21.536,8.966 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconInternet.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
